import { ContainerBloco, TituloBloco } from "../../../Common/styles";
import { IProposta } from "../../../../../utility/IProposta";
import BlocoPartesPrincipais from "./BlocoPartesPrincipais";
import BlocoOutrasPartes from "./BlocoOutrasPartes";
import { SectionDivider } from "../../../../CardDemanda/CabecalhoCardDemanda/styles";
import { Users } from "lucide-react";
import { comum } from "../../../../../styles/Themes/light";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ParteProcesso, ParteRepresentada } from "./interfaces";

interface BlocoPartesProps {
    demanda?: IProposta | null;
    loading?: boolean;
    isEditing?: boolean;
    isDisabled?: boolean;
    onChange?: (campo: string, valor: unknown) => void;
    onBlur?: (campo: string) => void;
    onPartesChange?: (partes: ParteProcesso[]) => void;
    onPartesRepresentadasChange?: (partes: ParteRepresentada[]) => void;
    errors?: Record<string, string>;
    onRecarregarDemanda?: () => void;
}

export default function BlocoPartes({demanda, loading = false, isEditing = false, isDisabled = false, onChange, onBlur, onPartesChange, onPartesRepresentadasChange, errors, onRecarregarDemanda}: BlocoPartesProps) {

    return (
        <ContainerBloco>
            {loading ? (
                <>
                    <Skeleton height={24} width="50%" style={{ marginBottom: '12px' }} />
                    <BlocoPartesPrincipais 
                        demanda={demanda} 
                        loading={loading} 
                        isEditing={isEditing} 
                        isDisabled={isDisabled}
                        onChange={onChange}
                        onBlur={onBlur}
                        errors={errors}
                        onRecarregarDemanda={onRecarregarDemanda} 
                    />
                    <SectionDivider />
                    <br />
                    <BlocoOutrasPartes 
                        partesProcesso={demanda?.partes_processo || []} 
                        partesRepresentadas={demanda?.partes_representadas || []} 
                        loading={loading} 
                        isEditing={isEditing} 
                        isDisabled={isDisabled}
                        onChange={onChange}
                        onPartesChange={onPartesChange}
                        onPartesRepresentadasChange={onPartesRepresentadasChange}
                    />
                </>
            ) : (
                <>
                    <TituloBloco>
                        <Users size={16} color={comum.colors.primaryRed400}/>
                        Partes Envolvidas
                    </TituloBloco>
                    <BlocoPartesPrincipais 
                        demanda={demanda} 
                        loading={loading} 
                        isEditing={isEditing} 
                        isDisabled={isDisabled}
                        onChange={onChange}
                        onBlur={onBlur}
                        errors={errors}
                        onRecarregarDemanda={onRecarregarDemanda} 
                    />
                    <SectionDivider />
                    <br />
                    <BlocoOutrasPartes 
                        partesProcesso={demanda?.partes_processo || []} 
                        partesRepresentadas={demanda?.partes_representadas || []} 
                        loading={loading} 
                        isEditing={isEditing} 
                        isDisabled={isDisabled}
                        onChange={onChange}
                        onPartesChange={onPartesChange}
                        onPartesRepresentadasChange={onPartesRepresentadasChange}
                    />
                </>
            )}
        </ContainerBloco>
    )
}

